<template>
  <div>
  <v-btn icon @click="showList" :title="$t('common.help')">
    <v-icon>fa-question-circle</v-icon>
  </v-btn>
    <v-dialog
        v-model="isVisibleList"
        scrollable
        max-width="1000"
        max-height="90%"
        min-width="600px"
    >
      <v-card
          height="100%"
          class="pa-2"
      >
          <v-list-item v-for="item in list" :key="item.title" class="pointer">
            <v-list-item-content>
              <v-list-item-title @click="showHelpTour(item)">
                {{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapFields} from "vuex-map-fields";

export default {
  data:()=>(
     {
      isVisibleList: false,
    }
  ),
  name: "HelpSystemComponent",
  computed:{
    list() {
      return [
        {
          title: this.$t('help.list.how_to_create_client_and_order'),
          routeName: 'customers'
        }
      ]
    },
    ...mapFields("helptour", ["helpsteps", "helpcallbacks", "currentHelpStep"]),
  },
  methods:{
    showList(){
      this.isVisibleList = true;
    },
    showHelpTour(item) {
      this.isVisibleList = false;
      if(this.$route.name !== item.routeName){
        this.$router.push({ name: item.routeName}).then(()=>{
            this.$emit('show')
        })
      } else {
          this.$emit('show')
      }
    },
  }
}
</script>

<style scoped>

</style>